import { AuthProvider } from "./contexts/auth.context";
import Home from "./pages/Home";
import Forum from "./pages/Forum";
import Search from "./pages/Search";
import Solution from "./pages/Solution";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import Profile from "./pages/Profile";
import Thread from "./pages/Thread";
import AskQuestion from "./pages/AskQuestion";
import Tags from "./pages/Tags";
import PageNotFound from "./pages/PageNotFound";
import NewTag from "./pages/NewTag";
import ForgetPassword from "./pages/ForgetPassword";
import ForumPageLayout from "./templates/ForumPageLayout";
import ProtectedRoutes from "./templates/ProtectedRoutes";

import { blue, orange } from "@mui/material/colors";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { createBrowserRouter, RouterProvider, Route, createRoutesFromElements } from "react-router-dom";
import React from "react";

const theme = createTheme({
    palette: {
        primary: blue,
        secondary: orange,
    },
});

const App: React.FC = () => {
    const router = createBrowserRouter(
        createRoutesFromElements(
            <Route path="/">
                <Route index element={<Home />} />
                <Route path="signin" element={<SignIn />} />
                <Route path="signup" element={<SignUp />} />
                <Route path="user/:id" element={<Profile />} />
                <Route path="forget-password" element={<ForgetPassword />} />
                <Route path="forum" element={<ForumPageLayout />}>
                    <Route index element={<Forum />} />
                    <Route path="search" element={<Search />} />
                </Route>
                <Route path="solution" element={<Solution />} />
                <Route path="tags" element={<ForumPageLayout />}>
                    <Route index element={<Tags />} />
                    <Route element={<ProtectedRoutes />}>
                        <Route path="new" element={<NewTag />} />
                    </Route>
                </Route>
                <Route path="question" element={<ForumPageLayout />}>
                    <Route element={<ProtectedRoutes />}>
                        <Route path="new" element={<AskQuestion />} />
                    </Route>
                    <Route path=":id">
                        <Route index element={<Thread />} />
                    </Route>
                </Route>
                <Route path="*" element={<PageNotFound />} />
            </Route>,
        ),
    );

    return (
        <div className="App">
            <ThemeProvider theme={theme}>
                <AuthProvider>
                    <RouterProvider router={router} />
                </AuthProvider>
            </ThemeProvider>
        </div>
    );
};

export default App;
